import { createContext } from 'react'

// Only the authenticated route owner supplies this context.
export const PersistentLayoutContext = createContext(null)
